export default __webpack_public_path__ + "static/sss2x-e8dbe0eaabd0d091afc38128b6aab01b.png";